import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'

import { UserByInstallationDto } from './dto/users-by-instalation-dto'
import { usersByInstallationTransformer } from './transformers/users-by-installation-transformer'
import { UserByInstallationModel } from './models/users-by-installation-model'
import { usePortalQuery } from 'src/Libs/api'

interface UseFetchUsersByInstallationHook {
  users: UserByInstallationModel[]
  isLoading: boolean
  isError: boolean
}

/**
 * Function for fetching users data by installation
 * @returns users as array of UserByInstallationModel, isLoading as boolean and isError as boolean
 * @param installationId as string
 */
export const useFetchUsersByInstallation = (installationId: number): UseFetchUsersByInstallationHook => {
  const authFetch = useAuthFetchWithResult()

  const fetchUsersByInstallationApi = async (): Promise<UserByInstallationDto[]> => {
    const fetchChargingCardsResponse = authFetch<UserByInstallationDto[]>({
      path: `users/installation/${installationId}`,
      endpoint: process.env.REACT_APP_HAGER_BRIDGE_SERVICE,
      method: 'GET',
    })

    const response = await fetchChargingCardsResponse
    return response
  }

  const { data, isLoading, isError } = usePortalQuery({
    queryFn: () => fetchUsersByInstallationApi(),
    queryKey: ['usersByInstallation'],
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  })

  const users = usersByInstallationTransformer(data ?? undefined)

  return {
    users,
    isLoading,
    isError,
  }
}
